/* ============================================
   FACE LED PRO - SHOPIFY THEME SCRIPTS
   GSAP Animations + Interactions
   ============================================ */

(function() {
  'use strict';

  /* ---- Header scroll effect ---- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ---- Mobile menu ---- */
  window.toggleMobileMenu = function() {
    const menu = document.getElementById('mobile-menu');
    if (menu) {
      menu.classList.toggle('active');
    }
  };

  /* ---- FAQ Accordion ---- */
  window.toggleFaq = function(button) {
    const item = button.parentElement;
    const isActive = item.classList.contains('active');
    document.querySelectorAll('.faq-item').forEach(function(faq) {
      faq.classList.remove('active');
    });
    if (!isActive) {
      item.classList.add('active');
    }
  };

  /* ---- Legal Accordion ---- */
  window.toggleLegal = function(button) {
    const item = button.parentElement;
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.legal-item').forEach(function(legal) {
      legal.classList.remove('open');
    });
    if (!isOpen) {
      item.classList.add('open');
    }
  };

  /* ---- Open Legal from Footer ---- */
  window.openLegalAndScroll = function(name) {
    document.querySelectorAll('.legal-item').forEach(function(item) {
      item.classList.remove('open');
    });
    const target = document.getElementById('legal-' + name);
    if (target) {
      target.classList.add('open');
      setTimeout(function() {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    }
  };

  /* ---- Hero entrance animation ---- */
  function animateHero() {
    const words = document.querySelectorAll('.hero-headline .word');
    words.forEach(function(word, i) {
      word.style.opacity = '0';
      word.style.transform = 'translateY(50px) rotateX(25deg)';
      setTimeout(function() {
        word.style.transition = 'all 0.9s cubic-bezier(0.16, 1, 0.3, 1)';
        word.style.opacity = '1';
        word.style.transform = 'translateY(0) rotateX(0)';
      }, 200 + i * 60);
    });
  }

  /* ---- GSAP ScrollTrigger Animations ---- */
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    // Product showcase (image left, info right)
    const productSection = document.querySelector('.section-product');
    if (productSection) {
      const media = productSection.querySelector('.product-media');
      const info = productSection.querySelector('.product-info');

      if (media) {
        gsap.fromTo(media,
          { x: -80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: productSection,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }

      if (info) {
        gsap.fromTo(info,
          { x: 80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: productSection,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }
    }

    // Hero parallax
    const heroSection = document.querySelector('.section-hero');
    if (heroSection) {
      gsap.to('.hero-bg', {
        y: '-8vh',
        scale: 1.06,
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: 'bottom top',
          scrub: 0.5
        }
      });
      gsap.to('.hero-content', {
        y: '-4vh',
        opacity: 0,
        scrollTrigger: {
          trigger: heroSection,
          start: '60% top',
          end: 'bottom top',
          scrub: 0.5
        }
      });
    }

    // Section reveal animations
    const revealSections = [
      '.section-light-modes',
      '.section-colors',
      '.section-intro',
      '.section-tech',
      '.section-authenticity',
      '.section-shipping',
      '.section-faq',
      '.section-legal'
    ];

    revealSections.forEach(function(selector) {
      const section = document.querySelector(selector);
      if (!section) return;

      gsap.fromTo(section,
        { y: 60, opacity: 0 },
        {
          y: 0, opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 85%',
            end: 'top 50%',
            scrub: 0.4
          }
        }
      );
    });

    // Staggered card reveals
    const staggerContainers = [
      '.variants-grid',
      '.modes-list',
      '.features-grid-2',
      '.faq-list',
      '.legal-list'
    ];

    staggerContainers.forEach(function(selector) {
      const container = document.querySelector(selector);
      if (!container) return;
      const children = container.children;

      gsap.fromTo(children,
        { y: 40, opacity: 0 },
        {
          y: 0, opacity: 1,
          duration: 0.8,
          stagger: 0.12,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: container,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        }
      );
    });

    // Tech row animations (text left, image right)
    document.querySelectorAll('.tech-row').forEach(function(row) {
      const content = row.querySelector('.tech-content');
      const image = row.querySelector('.tech-image');

      if (content) {
        gsap.fromTo(content,
          { x: -80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: row,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }

      if (image) {
        gsap.fromTo(image,
          { x: 80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: row,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }
    });

    // Our Story row animation (text left, image right)
    const ourStoryRow = document.querySelector('.our-story-row');
    if (ourStoryRow) {
      const text = ourStoryRow.querySelector('.our-story-text');
      const img = ourStoryRow.querySelector('.our-story-image');

      if (text) {
        gsap.fromTo(text,
          { x: -80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: ourStoryRow,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }

      if (img) {
        gsap.fromTo(img,
          { x: 80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: ourStoryRow,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }
    }

    // Light modes row animation (modes left, image right)
    const modesRow = document.querySelector('.light-modes-row');
    if (modesRow) {
      const list = modesRow.querySelector('.modes-list');
      const imgWrap = modesRow.querySelector('.modes-image-wrap');

      if (list) {
        gsap.fromTo(list,
          { x: -80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: modesRow,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }

      if (imgWrap) {
        gsap.fromTo(imgWrap,
          { x: 80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: modesRow,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }
    }

    // Transition bands
    document.querySelectorAll('.section-band').forEach(function(band) {
      const text = band.querySelector('.band-text-hero');
      if (text) {
        gsap.fromTo(text,
          { y: '25vh', scale: 0.92, opacity: 0 },
          {
            y: 0, scale: 1, opacity: 1,
            scrollTrigger: {
              trigger: band,
              start: 'top 80%',
              end: 'top 30%',
              scrub: 0.5
            }
          }
        );

        gsap.to(text, {
          x: '-18vw',
          opacity: 0,
          scrollTrigger: {
            trigger: band,
            start: '60% top',
            end: 'bottom top',
            scrub: 0.5
          }
        });
      }
    });

    // Shipping & Authenticity (text left, image right)
    const shippingAuthSection = document.querySelector('.section-shipping-auth');
    if (shippingAuthSection) {
      const stats = shippingAuthSection.querySelectorAll('.stat-num');
      const text = shippingAuthSection.querySelector('.shipping-auth-text');
      const img = shippingAuthSection.querySelector('.shipping-auth-image');

      gsap.fromTo(stats,
        { y: 30, opacity: 0 },
        {
          y: 0, opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: shippingAuthSection,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      if (text) {
        gsap.fromTo(text,
          { x: -80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: shippingAuthSection,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }

      if (img) {
        gsap.fromTo(img,
          { x: 80, opacity: 0 },
          {
            x: 0, opacity: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: shippingAuthSection,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      }
    }

    // Comparison table stagger
    const comparisonSection = document.querySelector('.section-comparison');
    if (comparisonSection) {
      const rows = comparisonSection.querySelectorAll('.comparison-table tbody tr');
      gsap.fromTo(rows,
        { x: -40, opacity: 0 },
        {
          x: 0, opacity: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: comparisonSection,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }

    // Glow CTA
    const glowCta = document.querySelector('.section-glow-cta');
    if (glowCta) {
      gsap.fromTo(glowCta.children,
        { y: 40, opacity: 0 },
        {
          y: 0, opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: glowCta,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }
  }

  /* ---- Initialize ---- */
  document.addEventListener('DOMContentLoaded', function() {
    animateHero();
    setTimeout(initGSAP, 500);
  });

})();
